import routes from './routes';

export default function Route(route, params = {}) {
    if (routes[route] === undefined) {
        console.error(`Route '${route}' not found!`);
    }

    Object.keys(params).forEach((key) => {
        routes[route] = routes[route].replace(`{${key}}`, params[key]);
    });

    return routes[route];
}
